"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Button_1 = require("../../../Button");
const ModalActions_1 = require("./ModalActions");
const ModalFooter = ({ loading, className, onAction, actionText, onCancel, cancelText, children, actionType, }) => {
    if (!actionText && !cancelText && !children)
        return null;
    return (react_1.default.createElement("footer", { className: (0, classnames_1.default)("gerudo-modal-footer", className) }, !children ? (react_1.default.createElement(Button_1.ButtonGroup, null,
        react_1.default.createElement(ModalActions_1.ModalActionButton, { type: actionType, loading: loading, onClick: onAction, text: actionText }),
        react_1.default.createElement(ModalActions_1.ModalCancelButton, { onClick: onCancel, text: cancelText, disabled: loading }))) : (children)));
};
exports.ModalFooter = ModalFooter;
exports.default = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map